import lfdcMin from 'assets/icons/lfdc.min.webp';
import lfdc from 'assets/icons/lfdc.webp';
import rapidstart from 'assets/icons/rapidstart.svg';
import prosp from 'assets/icons/prosp.svg';
import liftango from 'assets/icons/liftango.svg';
import anu from 'assets/icons/anu.svg';

const details = {
  name: {
    first: 'John',
    last: 'Lee',
    nickname: 'Ali',
  },
  education: [
    {
      school: 'Australian National University',
      url: 'https://www.anu.edu.au',
      icon: anu,
      iconMin: anu,
      location: 'Canberra, Australia',
      degree: 'Bachelor',
      major: 'Computer Science',
      start: 'Sep 2013',
      end: 'May 2016',
    },
  ],
  experience: [
    {
      company: 'Rapidstart',
      url: 'https://rapidstart.net/',
      icon: rapidstart,
      iconMin: rapidstart,
      location: 'Victoria, Australia',
      contract: 'Full-time',
      position: 'Lead Full Stack Engineer',
      start: 'Feb 2024',
      end: 'Present',
      description: [
        'Led the design and delivery of high-quality web applications using TypeScript, TailwindCSS, ShadcnUI, Next.js, Svelte, Node.js, and Supabase.',
        'Built and launched complex dashboards including CRM systems, Influencer marketplaces, AD campaign managers, AI-powered tools, and Kanban boards.',
        'Designed and developed backend services with Python and FastAPI, ensuring scalability and performance.',
        'Owned CI/CD pipelines and DevOps operations on AWS and Vercel, optimizing deployments and reliability.',
        'Collaborated with product owners, designers, QA, and engineering teams to deliver features aligned with business goals.',
        'Integrated multiple third-party APIs (REST and GraphQL) to enhance platform functionality and connectivity.',
      ],
      skills: [
        'Next',
        'React',
        'Svelte(Kit)',
        'Supabase',
        'Typescript',
        'Node.js',
        'Nest',
        'Python',
        'REST',
        'FastAPI',
        'AWS',
        'Docker',
        'Redux',
        'i18n',
        'Tailwind',
      ],
    },
    {
      company: 'Prosp',
      url: 'https://prosp.ai/',
      icon: prosp,
      iconMin: prosp,
      location: 'Paris, France',
      contract: 'Full-time',
      position: 'Senio Full Stack engineer',
      start: 'Nov 2021',
      end: 'Dec 2023',
      description: [
        'Lead the development of AI-powered web applications using, Typescript, Tailwind, MUI, React(Next), Node.js TypeScript, Supabase, delivering high-performance solutions that support mission-critical operations for clients.',
        'Implemented complex features leveraging OpenAI API and GPT-4, enhancing the intelligence and automation capabilities of the platform, resulting in a 30% increase in user engagement.',
        'Architected and optimized system architecture on GCP, improving scalability and reducing operational costs by 25%.',
        'Collaborated closely with UX/UI designers using Figma to create intuitive and visually appealing user interfaces, improving overall user satisfaction.',
        'Developed and integrated real-time feedback mechanisms using Supabase and Zustand, enabling dynamic user interaction and data-driven insights.',
        'Spearheaded the adoption of CI/CD pipelines using Jenkins and GitHub Actions, streamlining deployment processes and reducing time to market.',
      ],
      skills: ['React', 'Next', 'NodeJS', 'Nest', 'Supabase', 'UI/UX', 'Figma', 'OpenAIAPI', 'Python', 'FastAPI', 'AWS', 'Docker', 'Redux', 'i18n', 'Tailwind'],
    },
    {
      company: 'Liftango',
      url: 'https://www.liftango.com/',
      icon: liftango,
      iconMin: liftango,
      location: 'Vancouver, Canada',
      contract: 'Full-time',
      position: 'Full Stack Engineer',
      start: 'Jun 2019',
      end: 'Sep 2021',
      description: [
        'Built and maintained scalable web applications using Svelte, React, Express, and Firebase, driving the development of innovative products that served over 100,000 users globally.',
        'Developed RESTful APIs and integrated them with frontend components, ensuring seamless data exchange and optimal performance.',
        'Enhanced web security by implementing OAuth, JWT, and other best practices, protecting sensitive user data and maintaining compliance with industry standards.',
        'Worked on continuous integration and deployment (CI/CD) strategies using CircleCI, reducing deployment times by 40%.',
        'Participated in code reviews, mentoring junior developers, and promoting best practices in full-stack development.',
      ],
      skills: [
        'Svelte',
        'React',
        'Vue',
        'Mysql',
        'Prisma',
        'Node JS',
        'Express',
        'Chart.js',
        'Firebase',
        'OAuth',
        'JWT',
      ],
    },
    {
      company: 'APNIC',
      url: 'https://www.apnic.net/',
      icon: lfdc,
      iconMin: lfdcMin,
      location: 'Queensland, Australia',
      contract: 'Full-time',
      position: 'Front End Developer',
      start: 'Sep 2016',
      end: 'Mar 2019',
      description: [
        'Contributed to the development of e-commerce platforms using React, Vue and Node.js, focusing on enhancing user experience and increasing conversion rates.',
        'Managed backend services and databases, optimizing queries and data retrieval processes to improve application performance.',
        'Collaborated with cross-functional teams to deliver high-quality software solutions on time and within budget.',
        'Implemented automated testing frameworks, improving code quality and reducing the occurrence of bugs in production environments.',
      ],
      skills: ['React', 'Vue', 'Bootstrap'],
    },
  ],
  languages: [
    {
      name: 'English',
      level: 'C1',
      native: false,
    },
  ],
  contact: {
    address: 'Limerick, Ireland',
    email: 'ali.lee.0923@gmail.com',
    phone: '+353 061 748 990',
    website: 'https://alilee.vercel.app',
    linkedin: 'https://www.linkedin.com/in/ali-lee-6a9343389/',
    github: 'https://www.github.com/alilee0923',
    researchgate: 'https://www.researchgate.net/profile/alilee0923',
    gitlab: 'https://www.gitlab.com/alilee0923',
    deviantart: 'https://www.deviantart.com/alilee0923',
  },
};

export default details;
